<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="userForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="user" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                userForm: () => import('../forms/UserForm'),
                user: () => import('../editViews/User'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Auditor', value: 'auditorId', table: 'auditors', form: () => import('../forms/AuditorForm') },
                    { text: 'Email Address', value: 'emailAddress' },
                    { text: 'Is Email Confirmed', value: 'isEmailConfirmed' },
                    { text: 'Is Inactive', value: 'isInactive' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    auditors: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "emailAddress", direction: "ascending" },
                ],
                itemsField: 'users',
                editPageName: 'user',
                apiMethod: 'Users',
                claimName: 'Users',
                formTitle: 'User',
                excelTitle: 'Users',
                hasEditPage: true,
            }
        },
    };
</script>
